<template>
  <div>
    <el-form>
      <el-form-item prop="phone">
        <el-input class="phone" v-model="phone" placeholder="请输入手机号" style="width:88%;margin-left:35px;height:60px;margin-top:40px;">
          <template #prepend>+86</template>
          <template #append>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发送验证码&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="email">
        <el-input class="email_login" placeholder="请输入验证码"
          style="width:88%;margin-left:35px;height:60px;margin-top:15px;">
        </el-input>
      </el-form-item>
      <el-form-item prop="phone">
        <el-input v-model="phone" placeholder="请输入手机号" style="width:88%;margin-left:35px;height:60px;margin-top:15px;">
        </el-input>
      </el-form-item>
      <el-form-item prop="email">
        <el-input class="email_login" placeholder="请输入验证码"
          style="width:88%;margin-left:35px;height:60px;margin-top:15px;">
        </el-input>
      </el-form-item>
    </el-form>
    <div class="flex-row" style="width:100%;justify-content: space-around;">
      <button class="submitButton">提交</button>
      <router-link to="/store/entry/loginEmail">
        <button class="submitButton">返回</button>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeTab: 'login',
      phone: '',
      password: '',
      agree: false
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
::v-deep .el-input-group__append {
  border-radius: 0px 18px 18px 0px;
  font-size: large;
}

::v-deep .el-input-group__prepend {
  border-radius: 18px 0px 0px 18px;
  font-size: x-large;
}

::v-deep .el-input__inner {
  height: 60px;
  font-size: large;
  border-radius: 18px;
}

::v-deep .phone .el-input__inner {
  border-radius: 0px;
}

.submitButton {
  width:180px;height:50px;
  border-radius: 18px;
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
  margin-top: 20px;
  font-size: x-large;
  cursor: pointer;
}
</style>